<template>
  <div  >
    <Header
        @onRefreshClick="onRefresh"
        :leftArrow="true"
        :leftText="''"
        @leftClick="onClickLeft"
        :rightIcons="true"
    >
    </Header>
    <div class="home watch watch_movie">
      <div class="home_notice-search">
        <form >
          <input type="search" name="searchInput" placeholder="タイトル名を検索"  v-model="searchValue">
          <input type="submit" name="submit" value="検索" onclick="return false;">
        </form>
      </div>
      <div class="watch_wrap">
        <div class="watch_movie-list">
          <div class="movie-item" v-for="(item, index) in recordList" :key="index" v-show="!item.delete_flg && item.title.includes(searchValue)">
            <a  class="movie-item_link" @click="editRecord(item)">
              <div class="movie-item_img">
                <img :src="item.img_src" alt="" />
              </div>
              <p class="watch-item_info">
                <span class="movie-item_name">{{ item.title }}</span>
                <span class="movie-item_date">{{ item.record_start_at.substring(0, 10) }}</span>
                <span class="movie-item_time">{{ formatDate(item.record_start_at,item.record_end_at) }}</span>
              </p>
            </a>
            <button class="movie-remove-btn" @click.stop>
              <img src="@/assets/img/home/icon_remove.png" alt="" @click="openDialog(item)" >
            </button>
            <a @click="openDeleteDialog(item)"
               class="movie-remove-pop"
               :class="[item.status == 'open' ? 'open':'']">
              削除
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="movie-remove_modal" :class="[this.deleteDiaLogShow ? 'active' : '']">
    <div class="movie-remove_modal_inner">
      <p class="watch-end_modal_title">この録画を削除しますか？</p>
      <div class="movie-remove_btn">
        <a @click="closeDeleteDialog" class="btn-cancel">キャンセル</a>
        <a @click="deleteRecord" class="btn-end">削除する</a>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import { getVideoRecordList ,deleteRecord } from "@/services/video.js";
import { Toast } from 'vant';
import 'vant/es/toast/style';

export default {
  data() {
    return {
      recordList: [],
      videoSrc:null,
      deleteDiaLogShow:false,
      selectItem:null,
      searchValue:"",
      recordListInterval:null,
    };
  },
  components: {
    Header,
  },
  mounted() {
    this.initRecordList();
    document.addEventListener('click', this.closeDiaLog)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.closeDiaLog)
    if(this.recordListInterval){
      clearInterval(this.recordListInterval);
    }
  },
  created() {
    this.recordListInterval = setInterval(() => {
      this.initRecordList();
    }, 5000);
  },
  methods: {
    openDeleteDialog(item){
      this.deleteDiaLogShow = true;
      this.selectItem = item;
    },
    closeDeleteDialog(){
      this.deleteDiaLogShow = false;
      this.selectItem = null;
    },
    openDialog(item){
      this.closeDiaLog();
      item.status = 'open';
    },
    closeDiaLog(){
      this.recordList.forEach(item=>{
        item.status = 'close';
      });
    },
    formatDate(dateStart,dateEnd) {
      if(dateStart == dateEnd){
        return "0秒";
      }

      if(dateEnd == null || dateEnd ==""){
        return "";
      }

      const diff = Math.abs(new Date(dateEnd.replace(/-/g, "/")) - new Date(dateStart.replace(/-/g, "/")));
      const hours = Math.floor(diff / 1000 / 60 / 60);
      const minutes = Math.floor((diff / 1000 / 60) % 60);
      const seconds = Math.floor((diff / 1000) % 60);
      return (hours>0?hours+"時":"") +(minutes>0?minutes+"分":"") +(seconds>0?seconds+"秒":"");
    },
    onRefresh() {
      Toast.loading({
        message: "",
        forbidClick: true,
        duration: 1000,
        timer: null,
      });
      this.initRecordList();
    },
    deleteRecord(){
      deleteRecord({id:this.selectItem.id}).then((result) => {
        if (result.data.code >= 0) {
          if(result.data.data.error && result.data.data.error == 'auth_error'){
            Toast("権限が不足しています");
          }else{
            this.selectItem.delete_flg = true;
            Toast("削除に成功しました。");
          }
        } else {
          Toast("削除に失敗しました。");
        }
        this.closeDeleteDialog();
      });
    },
    editRecord(item){
        this.$router.push({
          path: "/recordDetail",
          query: {
            id: item.id,
          },
        });
    },
    onClickLeft() {
      history.back();
    },
    initRecordList(){
      getVideoRecordList().then((res) => {
        this.recordList = res.data.data.list;
      });
    }
  },
  watch: {},
};
</script>

<style scoped>
   
  
   

</style>
